import type { ClientOptions } from '@willbooster-private/kaizen-spring/browser';

// Local and test runs, including production builds started by E2E tests, must not reach the shared service.
export const isKaizenSpringEnabled =
  process.env.NEXT_PUBLIC_WB_ENV === 'staging' || process.env.NEXT_PUBLIC_WB_ENV === 'production';

export const kaizenSpringOptions: ClientOptions = {
  endpoint: 'https://kaizenspring.com',
  ingestKey: process.env.NEXT_PUBLIC_KAIZEN_SPRING_INGEST_KEY,
  environment: process.env.NEXT_PUBLIC_WB_ENV ?? 'development',
  // scripts/uploadSourceMaps.ts uploads the source maps under this release.
  release: process.env.NEXT_PUBLIC_WB_VERSION,
};
